import { memo } from 'react';

import { twMerge } from 'tailwind-merge';

import { FormControl, FormItem, FormLabel, FormMessage, Text } from '@/_components';

import { Preview } from './components';
import { IMAGE_FILE_TYPE_ACCEPTANCE } from './file-validations';
import { ImagePreviewModal } from './modal';
import type { MediaInputProps } from './type';
import { useImageInput } from './use-media-input';

export function FormMediaInputBase(props: MediaInputProps) {
  const { accept, requireName } = props;
  const allProps = useImageInput(props);
  const {
    handleImageSelector,
    handleFileChange,
    addPadding,
    inputRef,
    imageUrl,
    formItemClassName,
    label,
    disabled,
    shape,
    size,
    hideLabel,
    type,
    singleValue,
  } = allProps;

  let dimensions = size === 'lg' ? 'size-24 md:size-28' : 'size-24';
  if (shape === 'rectangle') {
    dimensions = size === 'lg' ? 'h-24 w-[7.84rem] md:h-28 md:w-[9.49rem]' : 'h-24 w-[7.84rem]';
  }
  if (size === 'fluid') {
    dimensions = 'w-full h-36';
  }

  return (
    <>
      <ImagePreviewModal {...allProps} />
      <input
        type="file"
        ref={inputRef}
        className="hidden"
        onChange={handleFileChange}
        accept={accept ?? IMAGE_FILE_TYPE_ACCEPTANCE}
      />
      <FormItem className={twMerge('overflow-hidden', dimensions, 'h-auto', formItemClassName)}>
        <FormControl>
          <div>
            <Preview
              src={imageUrl ?? ''}
              callback={handleImageSelector}
              disabled={disabled}
              shape={shape}
              dimensions={dimensions}
              addPadding={addPadding}
              type={type}
            >
              {singleValue?.name && requireName && (
                <Text as="p" className="text-accent break-before-all dark:text-white">
                  {singleValue?.name}
                </Text>
              )}
              {!hideLabel && label && <FormLabel>{label}</FormLabel>}
            </Preview>
          </div>
        </FormControl>
        <FormMessage forceHeight={false} />
      </FormItem>
    </>
  );
}

export const FormMediaInput = memo(FormMediaInputBase);
